import { createSelector } from 'reselect'

import { SUL_ANALYTICS_TYPES } from './constants'

const sulAnalyticsSelector = (state) => state.singleUseLinkAnalytics

const sulAnalyticsFormInitialValuesSelector = createSelector(sulAnalyticsSelector, ({ formInitialValues }) => formInitialValues)

const sulAnalyticsForSfCSelector = createSelector(sulAnalyticsSelector, (analytics) => (
  analytics[SUL_ANALYTICS_TYPES.SFC_CUSTOMIZED_DETAILS]
))

export {
  sulAnalyticsFormInitialValuesSelector,
  sulAnalyticsForSfCSelector
}
